import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { NiceModalComponent } from "components/context/NiceModalProvider";
import { ModelAsyncProcessesForm } from "models/async_processes/AsyncProcessesForm";

export default NiceModal.create(({ id, ...props }) => {
  const modal = useModal();

  return (
    <NiceModalComponent open={modal.visible} onClose={modal.hide}>
      <ModelAsyncProcessesForm {...props} onCancel={modal.hide} />
    </NiceModalComponent>
  );
});
